import React from 'react'
import { useTranslation } from 'react-i18next'

import { SanitizedHtml } from '../SanitizedHtml/SanitizedHtml'

interface ResidentDetailsHtmlProps {
  html: string | null
  className?: string
}

export const ResidentDetailsHtml: React.FC<ResidentDetailsHtmlProps> = ({
  html,
  className,
}) => {
  const { t } = useTranslation('common')
  if (!html) return null
  return (
    <div className={className}>
      <div className="font-semibold mb-2">{t('residentDetailsTitle')}</div>
      <SanitizedHtml html={html} />
    </div>
  )
}
